import { useNextNumberPreview } from "@/hooks/use-number-sequences";

import { CurrentWorkspaceEditDialog } from "./current-workspace-edit-dialog";
import { CurrentWorkspaceIdentityCard } from "./current-workspace-identity-card";
import { CurrentWorkspaceQuickConfig } from "./current-workspace-quick-config";

import type { WorkspaceProfileFormValues } from "./workspace-profile-schema";
import type { CategoryBonusRule, Workspace } from "@artisancode/api-types";
import type { UseFormReturn } from "react-hook-form";

interface Props {
  workspace: Workspace | null;
  canUpdate: boolean;
  bonusRules: CategoryBonusRule[];
  form: UseFormReturn<WorkspaceProfileFormValues>;
  isEditDialogOpen: boolean;
  onOpenEdit: () => void;
  onCloseEdit: () => void;
  onSubmit: (e?: React.BaseSyntheticEvent) => Promise<void>;
  isUpdating: boolean;
  onNavigateToBonusRules: () => void;
  onNavigateToNumberSequence: () => void;
}

export function CurrentWorkspaceProfileCard({
  workspace,
  canUpdate,
  bonusRules,
  form,
  isEditDialogOpen,
  onOpenEdit,
  onCloseEdit,
  onSubmit,
  isUpdating,
  onNavigateToBonusRules,
  onNavigateToNumberSequence,
}: Props) {
  const { preview: sequencePreview } = useNextNumberPreview(
    "sale",
    workspace?.id,
  );

  if (!workspace) return null;

  return (
    <div className="space-y-6">
      {/* Main Workspace Identity Card */}
      <CurrentWorkspaceIdentityCard
        workspace={workspace}
        canUpdate={canUpdate}
        onOpenEdit={onOpenEdit}
      />

      {/* Quick Config Cards: Bonus Rider, Penomoran, & Lingkup */}
      <CurrentWorkspaceQuickConfig
        workspaceName={workspace.name}
        bonusRules={bonusRules}
        sequencePreview={sequencePreview}
        onNavigateToBonusRules={onNavigateToBonusRules}
        onNavigateToNumberSequence={onNavigateToNumberSequence}
      />

      {/* Edit Workspace Dialog */}
      <CurrentWorkspaceEditDialog
        form={form}
        isOpen={isEditDialogOpen}
        onOpenChange={onCloseEdit}
        onSubmit={onSubmit}
        isUpdating={isUpdating}
      />
    </div>
  );
}
